export default "__VITE_ASSET__192af46f__"